import type { SavedViewConfig } from "@/lib/types/table";
import { PENDING_PUBLISH_STATUSES } from "./options";

/**
 * Saved views for the social media posts list. Mirrors the contracts saved-view
 * split (All + status slices). `filter_status` is the generic status filter key
 * the filter-conversion service maps onto the GraphQL `status` column.
 */
export const socialMediaPostSavedViews: SavedViewConfig[] = [
  {
    id: "all-social-posts",
    name: "All",
    filters: {},
    isDefault: true,
  },
  {
    id: "drafts",
    name: "Drafts",
    filters: { filter_status: ["draft"] },
  },
  {
    id: "scheduled",
    name: "Scheduled",
    filters: { filter_status: [...PENDING_PUBLISH_STATUSES] },
  },
  {
    id: "posted",
    name: "Posted",
    filters: { filter_status: ["posted"] },
  },
  {
    id: "failed",
    name: "Failed",
    filters: { filter_status: ["failed", "partially_failed"] },
  },
];
